module.exports = __webpack_public_path__ + "media/images/flags/4x3/pse-3a0dc2f0d457213afc630ffb5afa55ea.svg";